import React, { Fragment } from 'react';

import LifecycleProgress from 'app/developer-v3/components/SidebarRight/common/LifecycleProgress';
import {
  LifecycleJobStep,
  LifecycleStage,
} from 'app/entities/VersionLifecycle/types';

import Description from '../Description';

type Props = {
  currentStep: LifecycleJobStep;
  progress: number;
  stage: LifecycleStage;
};

function Progress({ currentStep, progress, stage }: Props) {
  return (
    <Fragment>
      <Description>
        We are running a number of tasks to promote your new version. This may
        take a while if your integration has a large user base. You can follow
        the promotion progress below.
      </Description>
      <LifecycleProgress
        currentStep={currentStep}
        progress={progress}
        stage={stage}
      />
    </Fragment>
  );
}

export default Progress;
